export const dialogSettingsSelector = (state) => state.dialogsSettings.dialogsSettings
export const isPhraseUpdatedSelector = (state) => state.dialogsSettings.isPhrasesUpdated
export const isGreetingUpdatedSelector = (state) => state.dialogsSettings.isGreetingUpdated
